"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-san-savino": {
    "dd9029ff": [{
      "hkey": "0b7f23cc",
      "slug": "alberoro-borghetto-vado",
      "name": "Alberoro-Borghetto-Vado",
      "primary": true,
      "skipSearch": false
    }],
    "alberoro": [{
      "hkey": "0b7f23cc",
      "slug": "alberoro-borghetto-vado",
      "name": "Alberoro-Borghetto-Vado",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;